import React, { FC } from 'react';

import { Box, Button } from '@mui/material';
import { noop } from 'lodash';
import { useTranslation } from 'next-i18next';

import LikeAndShareBundle from '@components/share/custom/likeAndShareBundle';
import PurchaseRemark from '@components/share/custom/purchaseRemark';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';

type EnrolledButtonProps = {
  bundleDetailSeo: BundleEntity;
  onClick: typeof noop;
  isFooter?: boolean;
  isDisableActionIcon?: boolean;
};

const EnrolledButton: FC<EnrolledButtonProps> = ({
  bundleDetailSeo,
  onClick,
  isFooter = false,
  isDisableActionIcon = false,
}) => {
  const { t } = useTranslation('store_course');

  return (
    <Box width="100%" display="grid" gridTemplateColumns={{ xs: isFooter ? '1fr 1fr' : '1fr', md: '1fr' }} gap={2}>
      <PurchaseRemark
        title={t('bundle_detail.header_banner.purchase.enrolled.remark.text')}
        icon="fa-light fa-check-circle"
        isFooter={isFooter}
        style={{ width: '100%' }}
      />
      <Box display="flex" width="100%" height={isFooter ? '40px' : '60px'}>
        <Button
          variant="outlined"
          fullWidth
          sx={{
            borderColor: 'white',
            color: 'white',
            minHeight: isFooter ? 40 : 60,
            fontSize: isFooter ? '18px' : '24px',
            fontWeight: 500,
            padding: 0,
          }}
          onClick={onClick}
        >
          {t('bundle_detail.header_banner.purchase.enrolled.button.text')}
        </Button>
        {/* TODO: implement like and share bundle */}
        {/* {!isDisableActionIcon && <LikeAndShareBundle bundleDetailSeo={bundleDetailSeo} />} */}
      </Box>
    </Box>
  );
};

export default EnrolledButton;
